import React from 'react';
import { useSelector } from 'react-redux';
import ApplicationDetails from 'Components/AdStatusBoard/ApplicationDetails';

const Phase1 = () => {
  const { user } = useSelector((state: any) => state.auth);
  return user.member_profile ? (
    <ApplicationDetails
      anonymous={false}
      applicantDetails={user.member_profile}
      applicantName={`${user.first_name} ${user.last_name}`}
      additionalInfo={{
        phone: user.phone,
        email: user.email,
      }}
    />
  ) : null;
};

export default Phase1;
